import { useState, useEffect } from "react";
import { Notification } from "../components/notification-bell";
import api from "../services/api";
import { useAppSelector } from "./hooks";
import { FaCar, FaCashRegister, FaIdCard, FaMoneyBill, FaMoneyCheck, FaMoneyCheckAlt, FaUserPlus } from "react-icons/fa";
import { FaHandshake, FaTrafficLight } from "react-icons/fa6";
import { FiBell } from "react-icons/fi";

export function useNotifications(idEmpresa: string) {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [token] = useState<string>(useAppSelector(state => state.token));
    const [resetNotifications, setResetNotifications] = useState(false);

    // Function to reset notification state (mark all as unread again)
    const resetNotificationState = () => {
        setResetNotifications(true);
        // Reset the flag after a short delay
        setTimeout(() => setResetNotifications(false), 100);
    };

    useEffect(() => {
        if (!idEmpresa) return;
        if (!token) return;

        async function fetchNotifications() {
            try {
                const { data } = await api.get(`/NotificacaoPorEmpresa/${idEmpresa}`);

                const formatted: Notification[] = data.map((n: any, index: any) => ({
                    id: index,
                    title: n.titulo,
                    description: n.descricao,
                    date: new Date(n.data),
                    priority: n.prioridade,
                    read: false,
                    url: n.url,
                    icon: n.categoria == "pagamento" ? FaCashRegister :
                        n.categoria == "lancamento" ? FaMoneyBill :
                            n.categoria == "licenciamento" ? FaCar :
                                n.categoria == "multa" ? FaTrafficLight :
                                    n.categoria == "locacao" ? FaHandshake : n.categoria == "habilitacao" ? FaIdCard :
                                        n.categoria == "afiliacao" ? FaUserPlus :
                                        FiBell
                }));

                setNotifications(formatted);
            } catch (error) {
                console.error("Erro ao buscar notificações:", error);
            }
        }

        fetchNotifications();

        const interval = setInterval(fetchNotifications, 60000);
        return () => clearInterval(interval);

    }, [idEmpresa, token]);

    return { 
        notifications, 
        setNotifications,
        resetNotificationState, // Export the reset function
        resetNotifications // Export the reset flag
    };
}